import styled from 'styled-components';

import { black, textGray, white } from '../../modules/colors';
import media from '../../modules/media';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.header`
  background-color: ${white};
  display: flex;
  justify-content: space-between;
  height: 68px;
  align-items: center;
  padding: ${spacing.lg}px;
  max-width: 1440px;
  margin: 0 auto;
`;

export const Brand = styled.a`
  display: inline-flex;
  font-size: ${fonts.xl}px;
  color: ${black};
  align-items: center;
`;

export const Logo = styled.img`
  height: 56px;
  margin-right: ${spacing.lg}px;
`;

export const MenuWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const Menu = styled.nav`
  display: inline-flex;
  align-items: center;

  ${media.desktop} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    background: ${black};
    ${(props) => (props.isOpen ? 'display: inline-flex;' : 'display: none;')}
  }
`;

export const MenuItem = styled.a`
  color: ${textGray};
  font-size: ${fonts.md}px;
  margin: 0px ${spacing.lg}px;
  cursor: pointer;
  ${(props) => (props.isOpen ? 'display: inline-block;' : 'display: none;')}

  :hover {
    opacity: 0.5;
    transition: opacity 0.5s;
  }

  ${media.desktop} {
    width: 100%;
    padding: ${spacing.lg}px 0;
    text-align: center;
    color: ${white};
  }
`;
